import { SVGProps } from "react";

export function Venn(props: SVGProps<SVGSVGElement>): React.ReactElement {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32 50.8126C28.8621 52.6278 25.2191 53.6667 21.3333 53.6667C9.55126 53.6667 0 44.1154 0 32.3333C0 20.5513 9.55126 11 21.3333 11C25.2191 11 28.8621 12.0389 32 13.854C35.1379 12.0389 38.7809 11 42.6667 11C54.4487 11 64 20.5513 64 32.3333C64 44.1154 54.4487 53.6667 42.6667 53.6667C38.7809 53.6667 35.1379 52.6278 32 50.8126ZM28.0219 47.846C25.9708 48.7316 23.7094 49.2222 21.3333 49.2222C12.0059 49.2222 4.44444 41.6608 4.44444 32.3333C4.44444 23.0059 12.0059 15.4444 21.3333 15.4444C23.7094 15.4444 25.9708 15.9351 28.0219 16.8206C23.9035 20.71 21.3333 26.2215 21.3333 32.3333C21.3333 38.4451 23.9035 43.9566 28.0219 47.846ZM35.9781 16.8206C38.0292 15.9351 40.2906 15.4444 42.6667 15.4444C51.9941 15.4444 59.5556 23.0059 59.5556 32.3333C59.5556 41.6608 51.9941 49.2222 42.6667 49.2222C40.2906 49.2222 38.0292 48.7316 35.9781 47.846C40.0965 43.9566 42.6667 38.4451 42.6667 32.3333C42.6667 26.2215 40.0965 20.71 35.9781 16.8206ZM32 19.2385C35.7973 22.3354 38.2222 27.0512 38.2222 32.3333C38.2222 37.6155 35.7973 42.3312 32 45.4282C28.2027 42.3312 25.7778 37.6155 25.7778 32.3333C25.7778 27.0512 28.2027 22.3354 32 19.2385Z"
        fill="black"
      />
    </svg>
  );
}
